// Copyright (c) 2022 WiseTime. All rights reserved.

import styled from "styled-components/macro"
import React from "react"
import { SnackBar } from "./actions"
import { Trans } from "@lingui/react"
import { LinkUnderlineSharedStyles } from "../shared/styles"

const ActionsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`

const ContactLink = styled.a`
  ${LinkUnderlineSharedStyles};
  font-size: 1.2rem;
`

const ErrorMessage = (snackBar: SnackBar): React.ReactElement => (
  <>
    {snackBar.message}
    <ActionsWrapper>
      <ContactLink
        href={"https://wisetime.com/contact/"}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Trans
          id="label_contact_wisetime"
          message="Contact WiseTime"
        />
      </ContactLink>
    </ActionsWrapper>
  </>
)

export default ErrorMessage
